<template>
  <div class="column gap-1 text-align-left">
    <p class="body">
      {{ $t('welcome.no_account') }}
      <a
        class="body"
        :href="serviceUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('welcome.customer_service') }}
      </a>
    </p>
  </div>
</template>

<script setup lang="ts">
const serviceUrl = process.env.VUE_APP_CUSTOMER_SERVICE_URL || '#';
</script>
